module.exports = __webpack_public_path__ + "img/ico_google_translate.ae298b7c.png";